import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/privacy/page.tsx");
